import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { PlansResponse } from '@/types'

export function usePlans() {
  return useQuery({
    queryKey: ['plans'],
    queryFn: async () => {
      return api.get<PlansResponse>('/plans')
    },
    staleTime: 1000 * 60 * 60, // 1 hour - plans don't change often
  })
}
